/* eslint-disable import/prefer-default-export */

// these products are used in calculator!

/* eslint-disable import/prefer-default-export */

// --- SAFE USE NOTES (by languages) ---
const SAFE_USE_NOTES = {
    UK: 'Use biocides safely. Always read the label and product information before use.',
    US: 'Use biocides safely. Always read the label and product information before use.',
    Canada: 'Use biocides safely. Always read the label and product information before use.',
    Denmark: 'Brug biocider sikkert. Læs altid etiketten og produktinformationen før brug.',
    Finland: 'Käytä biosideja turvallisesti. Lue aina etiketti ja tuotetiedot ennen käyttöä.',
    Norway:
        'Bruk biocider på en trygg måte. Les alltid etiketten og produktinformasjonen før bruk.',
    Sweden:
        'Använd biocider på ett säkert sätt. Läs alltid etiketten och produktinformationen före användning.',
    'Sweden - East Coast':
        'Använd biocider på ett säkert sätt. Läs alltid etiketten och produktinformationen före användning.',
    'Sweden - West Coast':
        'Använd biocider på ett säkert sätt. Läs alltid etiketten och produktinformationen före användning.',
    'Sweden - Lakes':
        'Använd biocider på ett säkert sätt. Läs alltid etiketten och produktinformationen före användning.',
    Germany:
        'Biozide sicher verwenden. Vor Gebrauch stets Kennzeichnung und Produktinformation lesen.',
    Netherlands:
        'Gebruik biociden veilig. Lees vóór gebruik altijd het etiket en de productinformatie.',
    France:
        'Utilisez les biocides avec précaution. Lisez toujours l’étiquette et les informations sur le produit avant utilisation.',
    Spain:
        'Utilice los biocidas de forma segura. Lea siempre la etiqueta y la información del producto antes de usarlo.',
    Greece:
        'Χρησιμοποιείτε τα βιοκτόνα με ασφαλή τρόπο. Διαβάζετε πάντα την ετικέτα και τις πληροφορίες του προϊόντος πριν από τη χρήση.',
    Croatia:
        'Biocide upotrebljavajte pažljivo. Prije uporabe uvijek pročitajte naljepnicu i informacije o proizvodu.',
    Italy:
        'Usare i biocidi con cautela. Leggere sempre l’etichetta e le informazioni sul prodotto prima dell’uso.'
}

export const hempelProducts = [
    {
        name: 'Silic One',
        productId: '77450',
        productUrl: 'https://www.hempelyacht.com/en-gb/silic-one',
        countryAllowed: [
            'UK',
            'Croatia',
            'Denmark',
            'Spain',
            'Norway',
            'Netherlands',
            'Finland',
            'Germany',
            // 'Greece',
            'Sweden - West Coast',
            'Sweden - East Coast',
            'Sweden - Lakes'
        ],
        position: 'alternative',
        priority: 2,
        img: '/images/products/77450-Silic-One-075.png',
        description:
            'Silic One is a biocide free, high solid fouling release system based on silicone and hydro gel. This gives a smooth even surface making it difficult for organisms to attach to the hull and facilitates self-cleaning when the boat is in motion. Suitable for use on all substrates, except wood, below the waterline.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers'],
        materialAllowed: ['aluminium', 'aluminum', 'fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['medium', 'high', 'low'],
        shades: ['#006394', '#B30033', '#000000'],
        coverage: 8,
        keyFeatures: [
            {
                UK: ['Biocide free fouling release system', 'Good protection']
            },
            {
                US: ['Biocide free fouling release system', 'Good protection']
            },
            {
                Canada: ['Biocide free fouling release system', 'Good protection']
            },
            {
                Croatia: ['Neobraštajući sustav bez sadržaja biocida', 'Završni premaz']
            },
            {
                Denmark: ['Biocidfri fouling release system', 'Topcoat']
            },
            {
                Spain: ['Sistema antiadherente libre de biocidas', 'Acabado']
            },
            {
                Norway: ['Biocid fritt groeavvisnings system', 'Toppstrøk']
            },
            {
                Netherlands: ['Biocide free frouling release system', 'Topcoat']
            },
            {
                Finland: ['Biosidivapaa kasvillisuutta hylkivä järjestelmä', 'Pintamaali']
            },
            {
                Germany: ['Biozidfreies Fouling-Release-System', 'Endanstrich']
            },
            {
                Greece: ['Σύστημα αντιρύπανσης χωρίς βιοκτόνα', 'Topcoat']
            },
            {
                'Sweden - West Coast': ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            {
                Sweden: ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            {
                'Sweden - Lakes': ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            { France: ['Biocide free fouling release system', 'Bonne protection'] }
        ],
        alternativeProducts: ['string'],
        dateUpdated: 'Wed Mar 28 2018 13:37:52 GMT+0200 (CEST)',
        updatedBy: 'web@burza.hr',
        id: 2
    },
    {
        name: 'Hempel’s Bravo II',
        productId: '76160',
        productUrl: 'https://www.hempelyacht.es/es-ES/products/hempels-bravo-76160',
        countryAllowed: ['Spain', 'France'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/76160-Bravo-2-25.png',
        description:
            'Antiincrustante de matriz insoluble. Proporciona una buena protección de fondos y líneas de flotación en las embarcaciones cuya velocidad no supera 20-30 nudos. Producto desarrollado especialmente para las aguas templadas. Para aplicar sobre todos los sustratos excepto el aluminio.',
        boatType: ['sailing'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean'],
        materialAllowed: ['wood', 'plywood', 'fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#B50938', '#000000', '#00275D', '#006394'],
        coverage: 18.8,
        alternativeProducts: '',
        keyFeatures: [
            { Denmark: ['Hardt bunnstoff', 'God beskyttelse'] },
            { Finland: ['Kova antifouling-maali', 'Hyvä suoja'] },
            { Norway: ['Hardt bunnstoff', 'God beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Bra skydd'] },
            { Germany: ['Hart-Antifouling', 'Guter Schutz'] },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Buena protección',
                    'Para barcos de alta actividad'
                ]
            },
            { Netherlands: ['Harde Antifouling', 'Goede bescherming'] },
            { UK: ['Hard antifouling', 'Good protection', 'For high activity boats'] },
            { US: ['Hard antifouling', 'Good protection', 'For high activity boats'] },
            { Canada: ['Hard antifouling', 'Good protection', 'For high activity boats'] },
            { France: ['Dur antifouling', 'Bonne protection', 'Pour les bateaux à haute activité'] }
        ],
        id: 3
    },
    {
        name: 'Hempel’s Broads',
        productId: '76111',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-broads-76111',
        countryAllowed: ['UK'],
        position: 'economic',
        priority: 0,
        img: '/images/products/76111-Broads-25.png',
        description:
            'Medium strength antifouling specifically designed to reduce paint build up and give a good performance on fresh, salt and brackish waters. It is suitable for all substrates except aluminium. The maximum launch time is one month.',
        boatType: ['sailing'],
        waterRestrictions: ['rivers'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'wood', 'plywood'],
        sailFrequency: ['low'],
        shades: ['#812E0F', '#000000', '#00275D', '#00754D'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz'] },
            { Denmark: ['Selbstpolierendes Antifouling', 'For cruising speeds'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Risteilynopeutta varten'] },
            { Norway: ['Selvpolerende bunnstoff'] },
            { Sweden: ['Självpolerande bottenfärg', 'För medelhöga marschfarter'] },
            { Germany: ['Selbstpolierendes Antifouling'] },
            { Spain: ['Antiincrustante autopulimentante'] },
            { Netherlands: ['Zelfpolijstende Antifouling'] },
            { UK: ['Self-polishing antifouling', 'For cruising speeds'] },
            { US: ['Self-polishing antifouling', 'For cruising speeds'] },
            { Canada: ['Self-polishing antifouling', 'For cruising speeds'] },
            { France: [] }
        ],
        id: 4
    },
    {
        name: 'Hempel’s Classic',
        productId: '71220',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-classic-antifouling-71220',
        countryAllowed: [
            'Croatia',
            'Finland',
            'Norway',
            'Spain',
            'Germany',
            'Netherlands',
            'Denmark'
        ],
        position: 'economic',
        priority: 2,
        img: '/images/products/71220-Classic-25.png',
        description:
            'Efficient polishing (erodible) antifouling providing good protection all season. As an antifouling for boats of glass fibre, wood, plywood and steel. Do not use on aluminium or other light-alloy metals. Risk of corrosion in case of direct contact. Suitable for cruising speeds.',
        boatType: ['sailing'],
        waterRestrictions: ['sea/ocean', 'sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low'],
        shades: ['#000000', '#00275D', '#00754D', '#812E0F'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Samopolirajući protuobraštajni premaz',
                    'Dobra zaštita',
                    'Idealan za laganu plovidbu'
                ]
            },
            { Denmark: ['Selvpolerende bundmaling', 'God beskyttelse', 'For marchhastigheder'] },
            {
                Finland: [
                    'Itsekiillottuva antifouling-maali',
                    'Hyvä suojaus',
                    'Alhaisemmille matkanopeuksille'
                ]
            },
            { Norway: ['Selvpolerende bunnstoff', 'God beskyttelse', 'For cruising hastigheter'] },
            { Sweden: ['Självpolerande bottenfärg', 'Bra skydd', 'För medelhöga marschfarter'] },
            {
                Germany: [
                    'Selbstpolierendes Antifouling',
                    'Guter Schutz',
                    'Für Reisegeschwindigkeiten'
                ]
            },
            {
                Spain: [
                    'Antifouling autopulimentante',
                    'Buena protección',
                    'Para velocidades de crucero'
                ]
            },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Goede bescherming'] },
            { UK: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { US: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { Canada: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { France: [] }
        ],
        id: 5
    },
    {
        name: 'Hempel’s Cruising Performer',
        productId: '7168E',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-cruising-performer-7168e',
        countryAllowed: ['Spain'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7168E-Cruising-Performer-25.png',
        description:
            'Self-polishing, erodible antifouling with very latest eroding technology which reduces the build up of paint, maximizing cruising capability in all areas, whilst ensuring fouling is kept to a minimum. An excellent coverage rate and colour stability ensures Hempel’s Cruising Performer offers you the very best in value. Suitable for use on all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#000000', '#00275D', '#006394', '#B50938'],
        coverage: 14.3,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Odlična zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Ausgezeichneter Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Excellent protection'] },
            { US: ['Self-polishing antifouling', 'Excellent protection'] },
            { Canada: ['Self-polishing antifouling', 'Excellent protection'] },
            { France: [] }
        ],
        id: 6
    },
    {
        name: 'Hempel’s Hard Racing',
        productId: '7668E',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-hard-racing-7668e',
        countryAllowed: ['UK'],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7668E-Hard-Racing-2,5.png',
        description:
            'Hard, high strength antifouling which gives a smooth racing finish, offering all round competitive performance. Formulated especially for power boats, racing yachts and vessels which are mud berthed. It may also be used on vessels that are dry sailed. Suitable for all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#000000', '#00275D', '#3B4550', '#B30033'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: [] }
        ],
        id: 7
    },
    {
        name: 'Hempel’s Hard Racing TecCel',
        productId: '76890',
        productUrl: 'https://www.hempelyacht.com/products/hempels-hard-racing-teccel-7679a',
        countryAllowed: ['Croatia', 'Spain'],
        position: 'premium',
        priority: 0,
        img: '/images/products/76890-Hard-Racing-TecCel-075.png',
        description:
            'Hardt bunnstoff som inneholder TecCel for en glatt overflate som reduserer friksjonen. Egnet for motorbåter, seilbåter, og hurtig gående båter. For bruk under vannlinjen på alle underlag inklusiv aluminium.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#00754D', '#006394', '#B30033'],
        coverage: 13.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: ['Dur antifouling', 'Excellente protection', 'Yachts à moteur et de régate'] }
        ],
        id: 9
    },
    {
        name: 'Hempel’s Hard Racing TecCel',
        productId: '7683A',
        productUrl: 'https://www.hempelyacht.com/products/hempels-hard-racing-teccel-7679a',
        countryAllowed: ['Norway', 'Germany'],
        position: 'premium',
        priority: 0,
        img: '/images/products/76890-Hard-Racing-TecCel-075.png',
        description:
            'Hardt bunnstoff som inneholder TecCel for en glatt overflate som reduserer friksjonen. Egnet for motorbåter, seilbåter, og hurtig gående båter. For bruk under vannlinjen på alle underlag inklusiv aluminium.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#00754D', '#006394', '#B30033'],
        coverage: 13.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: ['Dur antifouling', 'Excellente protection', 'Yachts à moteur et de régate'] }
        ],
        id: 10
    },
    {
        name: 'Hempel’s Hard Racing Xtra',
        productId: '7666A',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-hard-racing-xtra-7666a',
        countryAllowed: ['Denmark'],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7666A-Hard-Racing-Xtra-075.png',
        description:
            'Er en højtydende, hård antifouling, der giver fremragende beskyttelse og en glat racerfinish hele sæsonen. Som antifouling til både af glasfiber, træ, krydsfiner og stål. Må ikke anvendes på aluminium eller andre metallegeringer. Risiko for korrosion i tilfælde af direkte kontakt. Til motorbåde og regatta-yachter.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#006394', '#B30033', '#00275D'],
        coverage: 12.8,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: [] }
        ],
        id: 13
    },
    {
        name: 'Hempel’s Hard Racing Xtra',
        productId: '7666C',
        productUrl: 'https://www.hempelyacht.fi/fi-FI/products/hard-racing-xtra-7666w',
        countryAllowed: ['Finland'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7666W-Hard-Racing-Xtra-White-075.png',
        description:
            'Valkoinen, kova antifouling-maali. Erityisen sopiva nopeille moottoriveneille, kilpapurjeveneille ja traileriveneille. Hiottavissa erittäin sileäksi. Sopii kaikille pinnoille, paitsi alumiini. Käytetään vesilinjan alapuolella. Valkoinen sävy ei ole yhtä tehokas kuin muut sävyt, eli se toimii parhaiten kylmissä vesistöissä ja sitä on maalattava väh. 2 kerrosta/kausi. Vesillelasku aikaisintaan 24 tunnin jälkeen - viimeistään 6 kuukauden sisällä.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'wood',
            'plywood',
            'steel',
            'iron',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF'],
        coverage: 13,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: [] }
        ],
        id: 14
    },
    {
        name: 'Hempel’s Mille Light Copper',
        productId: '71430',
        productUrl: 'https://www.hempelyacht.se/sv-SE/products/hempels-mille-light-copper-71430',
        countryAllowed: ['Sweden - East Coast', 'Sweden - West Coast'],
        position: 'economic',
        priority: 2,
        img: '/images/products/71430-Mille-Light-Copper-075.png',
        description:
            'Erroderande kopparbaserad bottenfärg. För alla fartområden och alla material utom aluminium. Hempel’s Mille Light Copper får användas från Örskär till Norskagränsen. Overmålningsbar på alla polerande bottenfärger',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['Sweden - West Coast', 'Sweden - East Coast'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#D0CFC1', '#000000', '#00275D', '#006394', '#B50938'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Samopolirajući protuobraštajni premaz',
                    'Odlična zaštita',
                    'Za sjeverna mora'
                ]
            },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus', 'För Östersjön'] },
            {
                Germany: [
                    'Selbstpolierendes Antifouling',
                    'Ausgezeichneter Schutz',
                    'Für die Ostsee'
                ]
            },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente'] },
            {
                Netherlands: [
                    'Zelfpolijstende Antifouling',
                    'Uitstekende bescherming',
                    'Voor de Oostzee'
                ]
            },
            { UK: ['Self-polishing antifouling', 'Excellent protection', 'For Baltic Sea'] },
            { US: ['Self-polishing antifouling', 'Excellent protection', 'For Baltic Sea'] },
            { Canada: ['Self-polishing antifouling', 'Excellent protection', 'For Baltic Sea'] },
            { France: [] }
        ],
        id: 15
    },
    {
        name: 'Hempel’s Mille NCT',
        productId: '7173A',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-mille-nct-7183e',
        countryAllowed: ['Sweden - West Coast'],
        position: 'premium',
        priority: 1,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 13.8,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: ['Autolpolissant Antifouling', 'Protection exceptionnelle'] }
        ],
        id: 16
    },
    {
        name: 'Hempel’s Mille NCT',
        productId: '7183A',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-mille-nct-7183e',
        countryAllowed: ['Denmark', 'Norway', 'Germany', 'Sweden', 'Sweden - East Coast'],
        position: 'premium',
        priority: 2,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 13.8,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: [] }
        ],
        id: 17
    },
    {
        name: 'Hempel’s Mille NCT',
        productId: '71890',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-mille-nct-7183e',
        countryAllowed: ['Spain'],
        position: 'premium',
        priority: 2,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 13.8,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: ['Autolpolissant Antifouling', 'Protection exceptionnelle'] }
        ],
        id: 18
    },
    {
        name: 'Hempel’s Mille NCT',
        productId: '7173C',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-mille-nct-7183e',
        countryAllowed: ['Netherlands'],
        position: 'premium',
        priority: 2,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean', 'wood', 'plywood'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 13.8,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: ['Autolpolissant Antifouling', 'Protection exceptionnelle'] }
        ],
        id: 19
    },
    {
        name: 'Hempel’s Mille Standard',
        productId: '7175A',
        productUrl: 'https://www.hempelyacht.no/nb-NO/products/hempels-mille-standard-7175a',
        countryAllowed: ['Norway'],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7175A-Mille-Standard-075.png',
        description:
            'Meget effektivt selvpolerende bunnstoff basert på spesialbindemidler. Gir en aktiv overflate som blir kontinuerlig fornyet slik at du får et rent og raskt skrog hele sesongen.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#000000', '#3B4550'],
        coverage: 14,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: [] }
        ],
        id: 23
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: 'https://www.hempelyacht.com/sv-se/products/hempaspeed-tf-77222',
        countryAllowed: ['Sweden', 'Sweden - West Coast', 'Sweden - East Coast', 'Sweden - Lakes'],
        position: 'best-buy-alternative',
        priority: 2,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 26
    },
    {
        name: 'Hempel’s Mille Xtra',
        productId: '7166C',
        productUrl: 'https://www.hempelyacht.fi/fi-FI/products/hempels-mille-xtra-7166c',
        countryAllowed: ['Finland', 'Denmark', 'Netherlands'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7166A-Mille-Xtra-25.png',
        description:
            'Hempel’s mest solgte bundmaling til lystbåde! Udviklet specielt til bådejere, der stiller meget høje krav til beskyttelse mod begroninger i saltvand. En polerende bundmaling, som er let at arbejde med. Velegnet til en fart op til 25 knob.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 14,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: [] }
        ],
        id: 27
    },
    {
        name: 'Hempel’s Tiger Xtra',
        productId: '71000',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-tiger-xtra-71000',
        countryAllowed: ['UK'],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/71000-Tiger-Xtra-25.png',
        description:
            'Self-polishing, erodible antifouling. Suitable to both power and sail boats and just 1 coat can last the season. Applying a second coat for year round protection gives excellent and consistent long term performance, under all conditions. It is suitable for use on all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-fast', 'motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#3B4550', '#00754D', '#B30033'],
        coverage: 12.8,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Odlična zaštita'] },
            { Denmark: ['Meget god beskyttelse'] },
            { Finland: ['Erittäin hyvä suojaus'] },
            { Norway: ['Meget god beskyttelse'] },
            { Sweden: ['Erittäin hyvä suojaus'] },
            { Germany: ['Ausgezeichneter Schutz'] },
            { Spain: ['Protección excelente'] },
            { Netherlands: ['Uitstekende bescherming'] },
            { UK: ['Erodible antifouling', 'Excellent protection'] },
            { US: ['Erodible antifouling', 'Excellent protection'] },
            { Canada: ['Erodible antifouling', 'Excellent protection'] },
            { France: [] }
        ],
        id: 30
    },
    {
        name: 'Hempel’s Tiger Xtra (white)',
        productId: '7103A',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-tiger-xtra-white-7103a',
        countryAllowed: ['UK'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7103A-Tiger-Xtra-White-25.png',
        description:
            'High performance, self-polishing antifouling providing excellent protection all season. As an antifouling for boats of glass fibre, wood, plywood, steel and aluminium.',
        boatType: ['motor-fast', 'motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'high'],
        shades: ['#FFFFFF'],
        coverage: 13.3,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Odlična zaštita'] },
            { Denmark: ['Meget god beskyttelse'] },
            { Finland: ['Erittäin hyvä suojaus'] },
            { Norway: ['Meget god beskyttelse'] },
            { Sweden: ['Erittäin hyvä suojaus'] },
            { Germany: ['Ausgezeichneter Schutz'] },
            { Spain: ['Protección excelente'] },
            { Netherlands: ['Uitstekende bescherming'] },
            { UK: ['Erodible antifouling', 'Excellent protection'] },
            { US: ['Erodible antifouling', 'Excellent protection'] },
            { Canada: ['Erodible antifouling', 'Excellent protection'] },
            { France: [] }
        ],
        id: 31
    },
    {
        name: 'EcoPower Cruise',
        productId: '72460',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-ecopower-cruise-72460',
        countryAllowed: [
            'Sweden - West Coast',
            'Sweden - East Coast',
            'Sweden - Lakes',
            'Denmark',
            'Finland',
            'Germany',
            'Netherlands'
        ],
        position: 'economic',
        priority: 2,
        img: '/images/products/72460-Ecopower-Cruise-075.png',
        description:
            'Hempel’s EcoPower Cruise is a biocide free bottom paint protecting the epoxy coating from fouling. An advanced binder technology controls the self-renewing effect throughout the season. Eliminates copper leakage from old antifouling when used together with Hempel’s Underwater Primer.',
        boatType: ['sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'steel',
            'iron',
            'wood',
            'plywood',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        coverage: 14.3,
        keyFeatures: [
            {
                UK: ['Self-polishing biocide free bottom paint']
            },
            {
                US: ['Self-polishing biocide free bottom paint']
            },
            {
                Canada: ['Self-polishing biocide free bottom paint']
            },
            {
                Denmark: ['Selvpolerende biocidfri bundmaling']
            },
            {
                Finland: ['Itseilevä biosidivapaa pohjamaali']
            },
            {
                Norway: ['Selvpolerende biocidfri bunnfarge']
            },
            {
                Sweden: ['Koppar och zinkfri bottenfärg']
            },
            {
                'Sweden - West Coast': ['Koppar och zinkfri bottenfärg']
            },
            {
                'Sweden - Lakes': ['Koppar och zinkfri bottenfärg']
            },
            {
                Spain: ['Antifouling tvrdog tipa bez biocida']
            },
            {
                Croatia: ['Samopolirajući antifouling bez biocida']
            },
            {
                Germany: ['Selbstpolierendes biozidfreies Antifouling']
            },
            {
                Netherlands: ['Zelfpolijstende biocidevrije antifouling']
            },
            {
                Greece: ['Αυτο-στίλβωση χωρίς βιοκτόνα αντιρρυπαντικά']
            },
            { France: [] }
        ],
        alternativeProducts: ['string'],
        dateUpdated: 'Wed Mar 28 2018 13:34:23 GMT+0200 (CEST)',
        updatedBy: 'web@burza.hr',
        id: 32
    },
    {
        name: 'EcoPower Racing',
        productId: '76460',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-ecopower-racing-76460',
        countryAllowed: ['Denmark'],
        position: 'economic',
        priority: 1,
        img: '/images/products/76460-Ecopower-Racing-075.png',
        description: 'string',
        boatType: ['motor-fast', 'motor-slow'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'steel',
            'iron',
            'wood',
            'plywood',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        coverage: 12.5,
        keyFeatures: [
            {
                UK: ['Hard biocide free bottom paint']
            },
            {
                US: ['Hard biocide free bottom paint']
            },
            {
                Canada: ['Hard biocide free bottom paint']
            },
            {
                Denmark: ['Hårdt biocidfri bundmaling']
            },
            {
                Finland: ['Kova biosidivapaa pohjamaali']
            },
            {
                Norway: ['Hard biocidfri bunnfarge']
            },
            {
                Sweden: ['Hård och zinkfri bottenfärg']
            },
            {
                'Sweden - West Coast': ['Hård och zinkfri bottenfärg']
            },
            {
                'Sweden - Lakes': ['Hård och zinkfri bottenfärg']
            },
            {
                Spain: ['Antifouling duro sin biocida']
            },
            {
                Croatia: ['Antifouling tvrdog tipa bez biocida']
            },
            {
                Germany: ['Biozidfreies Hart-Antifouling']
            },
            {
                Netherlands: ['Harde biocidevrije antifouling']
            },
            {
                Greece: ['Σκληρό αντιρρυπαντικό χωρίς βιοκτόνα']
            },
            { France: [] }
        ],
        alternativeProducts: ['string'],
        dateUpdated: 'Wed Mar 28 2018 13:34:23 GMT+0200 (CEST)',
        updatedBy: 'web@burza.hr',
        id: 33
    },
    {
        name: 'Hempel’s Hard Racing Xtra',
        productId: '7666C',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-hard-racing-xtra-7666a',
        countryAllowed: ['Netherlands'],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7666A-Hard-Racing-Xtra-075.png',
        description:
            'Er en højtydende, hård antifouling, der giver fremragende beskyttelse og en glat racerfinish hele sæsonen. Som antifouling til både af glasfiber, træ, krydsfiner og stål. Må ikke anvendes på aluminium eller andre metallegeringer. Risiko for korrosion i tilfælde af direkte kontakt. Til motorbåde og regatta-yachter.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#006394', '#B30033', '#00275D'],
        coverage: 12.8,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: [] }
        ],
        id: 34
    },
    {
        name: 'Hempel’s Mille Xtra (Dove White)',
        productId: '7166A',
        productUrl: 'https://www.hempelyacht.fi/fi-FI/products/hempels-mille-xtra-7166c',
        countryAllowed: ['Denmark', 'Finland', 'Norway'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7166A-Mille-Xtra-25.png',
        description:
            'Hempel’s mest solgte bundmaling til lystbåde! Udviklet specielt til bådejere, der stiller meget høje krav til beskyttelse mod begroninger i saltvand. En polerende bundmaling, som er let at arbejde med. Velegnet til en fart op til 25 knob.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 14,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: [] }
        ],
        id: 35
    },
    {
        name: 'Hempel’s Mille NCT',
        productId: '71890',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-mille-nct-7183e',
        countryAllowed: ['Croatia'],
        position: 'premium',
        priority: 1,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 13.8,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: ['Autolpolissant Antifouling', 'Protection exceptionnelle'] }
        ],
        id: 40
    },
    {
        name: 'Hempel’s Hard Racing TecCel (white)',
        productId: '7679A',
        productUrl:
            'https://www.hempelyacht.com/en-GB/products/hempels-hard-racing-teccel-white-7679a',
        countryAllowed: ['UK'],
        position: 'premium',
        priority: 0,
        img: '/images/products/7679A-HardRacingTeccel-2,5.png',
        description:
            'High performance, hard antifouling providing outstanding protection all season. Includes TecCel technology which ensures reduced friction and increased speed. Can be used on glass fibre, wood, plywood, steel and aluminium. For power boats and regatta yachts.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'wood',
            'plywood',
            'steel',
            'iron',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: ['Dur antifouling', 'Excellente protection', 'Yachts à moteur et de régate'] }
        ],
        id: 44
    },
    {
        name: 'Hempel’s Classic',
        productId: '71220',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-classic-antifouling-71220',
        countryAllowed: ['Sweden - West Coast'],
        position: 'economic',
        priority: 0,
        img: '/images/products/71220-Classic-25.png',
        description:
            'Efficient polishing (erodible) antifouling providing good protection all season. As an antifouling for boats of glass fibre, wood, plywood and steel. Do not use on aluminium or other light-alloy metals. Risk of corrosion in case of direct contact. Suitable for cruising speeds.',
        boatType: ['sailing'],
        waterRestrictions: ['Sweden - West Coast'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low'],
        shades: ['#000000', '#00275D', '#00754D', '#812E0F'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Samopolirajući protuobraštajni premaz',
                    'Dobra zaštita',
                    'Idealan za laganu plovidbu'
                ]
            },
            { Denmark: ['Selvpolerende bundmaling', 'God beskyttelse', 'For marchhastigheder'] },
            {
                Finland: [
                    'Itsekiillottuva antifouling-maali',
                    'Hyvä suojaus',
                    'Alhaisemmille matkanopeuksille'
                ]
            },
            { Norway: ['Selvpolerende bunnstoff', 'God beskyttelse', 'For cruising hastigheter'] },
            { Sweden: ['Självpolerande bottenfärg', 'Bra skydd', 'För medelhöga marschfarter'] },
            {
                Germany: [
                    'Selbstpolierendes Antifouling',
                    'Guter Schutz',
                    'Für Reisegeschwindigkeiten'
                ]
            },
            {
                Spain: [
                    'Antifouling autopulimentante',
                    'Buena protección',
                    'Para velocidades de crucero'
                ]
            },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Goede bescherming'] },
            { UK: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { US: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { Canada: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { France: [] }
        ],
        id: 51
    },
    {
        name: 'Hempel’s Classic',
        productId: '71220',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-classic-antifouling-71220',
        countryAllowed: ['UK'],
        position: 'economic',
        priority: 0,
        img: '/images/products/71220-Classic-25.png',
        description:
            'Efficient polishing (erodible) antifouling providing good protection all season. As an antifouling for boats of glass fibre, wood, plywood and steel. Do not use on aluminium or other light-alloy metals. Risk of corrosion in case of direct contact. Suitable for cruising speeds.',
        boatType: ['sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'wood', 'plywood'],
        sailFrequency: ['low'],
        shades: ['#000000', '#00275D', '#00754D', '#812E0F'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Samopolirajući protuobraštajni premaz',
                    'Dobra zaštita',
                    'Idealan za laganu plovidbu'
                ]
            },
            { Denmark: ['Selvpolerende bundmaling', 'God beskyttelse', 'For marchhastigheder'] },
            {
                Finland: [
                    'Itsekiillottuva antifouling-maali',
                    'Hyvä suojaus',
                    'Alhaisemmille matkanopeuksille'
                ]
            },
            { Norway: ['Selvpolerende bunnstoff', 'God beskyttelse', 'For cruising hastigheter'] },
            { Sweden: ['Självpolerande bottenfärg', 'Bra skydd', 'För medelhöga marschfarter'] },
            {
                Germany: [
                    'Selbstpolierendes Antifouling',
                    'Guter Schutz',
                    'Für Reisegeschwindigkeiten'
                ]
            },
            {
                Spain: [
                    'Antifouling autopulimentante',
                    'Buena protección',
                    'Para velocidades de crucero'
                ]
            },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Goede bescherming'] },
            { UK: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { US: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { Canada: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { France: [] }
        ],
        id: 52
    },
    {
        name: 'Hempel’s Mille Xtra (Dove White)',
        productId: '7166C',
        productUrl: 'https://www.hempelyacht.fi/fi-FI/products/hempels-mille-xtra-7166c',
        countryAllowed: ['Netherlands'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7166A-Mille-Xtra-25.png',
        description:
            'Hempel’s mest solgte bundmaling til lystbåde! Udviklet specielt til bådejere, der stiller meget høje krav til beskyttelse mod begroninger i saltvand. En polerende bundmaling, som er let at arbejde med. Velegnet til en fart op til 25 knob.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 14,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] },
            { Canada: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: [] }
        ],
        id: 57
    },
    {
        name: 'Hempel’s Cruising Performer',
        productId: '7168E',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-cruising-performer-7168e',
        countryAllowed: ['UK'],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7168E-Cruising-Performer-25.png',
        description:
            'Self-polishing, erodible antifouling with very latest eroding technology which reduces the build up of paint, maximizing cruising capability in all areas, whilst ensuring fouling is kept to a minimum. An excellent coverage rate and colour stability ensures Hempel’s Cruising Performer offers you the very best in value. Suitable for use on all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#000000', '#00275D', '#006394', '#B50938'],
        coverage: 14.3,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Odlična zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Ausgezeichneter Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Excellent protection'] },
            { France: [] }
        ],
        id: 58
    },
    {
        name: 'Hempel’s Cruising Performer (Dove White)',
        productId: '7168E',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-cruising-performer-7168e',
        countryAllowed: ['Croatia'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7168E-Cruising-Performer-25.png',
        description:
            'Self-polishing, erodible antifouling with very latest eroding technology which reduces the build up of paint, maximizing cruising capability in all areas, whilst ensuring fouling is kept to a minimum. An excellent coverage rate and colour stability ensures Hempel’s Cruising Performer offers you the very best in value. Suitable for use on all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium'],
        shades: ['#000000', '#00275D', '#006394', '#B50938'],
        coverage: 14.3,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Odlična zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Ausgezeichneter Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Excellent protection'] },
            { France: [] }
        ],
        id: 59
    },
    {
        name: 'EcoPower Racing',
        productId: '76460',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-ecopower-racing-76460',
        countryAllowed: [
            'Finland',
            'Germany',
            'Netherlands',
            'Sweden - West Coast',
            'Sweden - East Coast',
            'Sweden - Lakes'
        ],
        position: 'economic',
        priority: 0,
        img: '/images/products/76460-Ecopower-Racing-075.png',
        description: 'string',
        boatType: ['motor-fast', 'motor-slow'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'steel',
            'iron',
            'wood',
            'plywood',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        coverage: 12.5,
        keyFeatures: [
            {
                UK: ['Hard biocide free bottom paint']
            },
            {
                Denmark: ['Hårdt biocidfri bundmaling']
            },
            {
                Finland: ['Kova biosidivapaa pohjamaali']
            },
            {
                Norway: ['Hard biocidfri bunnfarge']
            },
            {
                Sweden: ['Hård och zinkfri bottenfärg']
            },
            {
                'Sweden - West Coast': ['Hård och zinkfri bottenfärg']
            },
            {
                'Sweden - Lakes': ['Hård och zinkfri bottenfärg']
            },
            {
                Spain: ['Antifouling duro sin biocida']
            },
            {
                Croatia: ['Antifouling tvrdog tipa bez biocida']
            },
            {
                Germany: ['Biozidfreies Hart-Antifouling']
            },
            {
                Netherlands: ['Harde biocidevrije antifouling']
            },
            {
                Greece: ['Σκληρό αντιρρυπαντικό χωρίς βιοκτόνα']
            },
            { France: [] }
        ],
        alternativeProducts: ['string'],
        dateUpdated: 'Wed Mar 28 2018 13:34:23 GMT+0200 (CEST)',
        updatedBy: 'web@burza.hr',
        id: 63
    },
    {
        name: 'EcoPower Cruise',
        productId: '76460',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-ecopower-racing-76460',
        countryAllowed: ['UK'],
        position: 'economic',
        priority: 2,
        img: '/images/products/76460-Ecopower-Racing-075.png',
        description: 'string',
        boatType: ['sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'steel',
            'iron',
            'wood',
            'plywood',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        coverage: 12.5,
        keyFeatures: [
            {
                UK: ['Hard biocide free bottom paint']
            },
            {
                Denmark: ['Hårdt biocidfri bundmaling']
            },
            {
                Finland: ['Kova biosidivapaa pohjamaali']
            },
            {
                Norway: ['Hard biocidfri bunnfarge']
            },
            {
                Sweden: ['Hård och zinkfri bottenfärg']
            },
            {
                'Sweden - West Coast': ['Hård och zinkfri bottenfärg']
            },
            {
                'Sweden - Lakes': ['Hård och zinkfri bottenfärg']
            },
            {
                Spain: ['Antifouling duro sin biocida']
            },
            {
                Croatia: ['Antifouling tvrdog tipa bez biocida']
            },
            {
                Germany: ['Biozidfreies Hart-Antifouling']
            },
            {
                Netherlands: ['Harde biocidevrije antifouling']
            },
            {
                Greece: ['Σκληρό αντιρρυπαντικό χωρίς βιοκτόνα']
            },
            { France: [] }
        ],
        alternativeProducts: ['string'],
        dateUpdated: 'Wed Mar 28 2018 13:34:23 GMT+0200 (CEST)',
        updatedBy: 'web@burza.hr',
        id: 64
    },
    {
        name: 'Hempel’s Mille NCT (white)',
        productId: '7174A',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-mille-nct-7174a',
        countryAllowed: ['UK'],
        position: 'premium',
        priority: 1,
        img: '/images/products/7174A-Mille-NCT-White-075.png',
        description:
            'Is high performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling protection and colour retention all season. As an antifouling for boats of glass fibre, wood, plywood, steel and aluminium.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'steel',
            'iron',
            'iron',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF'],
        coverage: 13.3,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: ['Autolpolissant Antifouling', 'Protection exceptionnelle'] }
        ],
        id: 65
    },
    {
        name: 'Hempel’s Mille NCT',
        productId: '71890',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-mille-nct-7183e',
        countryAllowed: ['France', 'Greece'],
        position: 'premium',
        priority: 2,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'wood', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#006394', '#B30033'],
        coverage: 13.8,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { France: ['Autolpolissant Antifouling', 'Protection exceptionnelle'] }
        ],
        id: 67
    },
    {
        name: 'Hempel’s Hard Racing TecCel',
        productId: '76890',
        productUrl: 'https://www.hempelyacht.com/products/hempels-hard-racing-teccel-7679a',
        countryAllowed: ['France', 'Greece'],
        position: 'premium',
        priority: 1,
        img: '/images/products/76890-Hard-Racing-TecCel-075.png',
        description:
            'Hardt bunnstoff som inneholder TecCel for en glatt overflate som reduserer friksjonen. Egnet for motorbåter, seilbåter, og hurtig gående båter. For bruk under vannlinjen på alle underlag inklusiv aluminium.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#00275D', '#00754D', '#006394', '#B30033'],
        coverage: 13.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: ['Dur antifouling', 'Excellente protection', 'Yachts à moteur et de régate'] }
        ],
        id: 69
    },
    {
        name: 'Silic One',
        productId: '77450',
        productUrl: 'https://www.hempelyacht.com/en-gb/silic-one',
        countryAllowed: ['France', 'Greece'],
        position: 'alternative',
        priority: 2,
        img: '/images/products/77450-Silic-One-075.png',
        description:
            'Silic One is a biocide free, high solid fouling release system based on silicone and hydro gel. This gives a smooth even surface making it difficult for organisms to attach to the hull and facilitates self-cleaning when the boat is in motion. Suitable for use on all substrates, except wood, below the waterline.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers'],
        materialAllowed: ['aluminium', 'aluminum', 'fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['medium', 'high', 'low'],
        shades: ['#006394', '#B30033', '#000000'],
        coverage: 8,
        keyFeatures: [
            {
                UK: ['Biocide free fouling release system', 'Good protection']
            },
            {
                Croatia: ['Neobraštajući sustav bez sadržaja biocida', 'Završni premaz']
            },
            {
                Denmark: ['Biocidfri fouling release system', 'Topcoat']
            },
            {
                Spain: ['Sistema antiadherente libre de biocidas', 'Acabado']
            },
            {
                Norway: ['Biocid fritt groeavvisnings system', 'Toppstrøk']
            },
            {
                Netherlands: ['Biocide free frouling release system', 'Topcoat']
            },
            {
                Finland: ['Biosidivapaa kasvillisuutta hylkivä järjestelmä', 'Pintamaali']
            },
            {
                Germany: ['Biozidfreies Fouling-Release-System', 'Endanstrich']
            },
            {
                Greece: ['Σύστημα αντιρύπανσης χωρίς βιοκτόνα', 'Topcoat']
            },
            {
                'Sweden - West Coast': ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            {
                Sweden: ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            {
                'Sweden - Lakes': ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            { France: ['Biocide free fouling release system', 'Bonne protection'] }
        ],
        alternativeProducts: ['string'],
        dateUpdated: 'Wed Mar 28 2018 13:37:52 GMT+0200 (CEST)',
        updatedBy: 'web@burza.hr',
        id: 71
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: 'https://www.hempelyacht.com/en-us/products/hempaspeed-tf-77222',
        countryAllowed: ['US', 'Canada'],
        position: 'best-buy-alternative',
        priority: 3,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 72
    },
    {
        name: 'Silic One',
        productId: '77450',
        productUrl: 'https://www.hempelyacht.com/en-gb/silic-one',
        countryAllowed: ['US', 'Canada'],
        position: 'alternative',
        priority: 1,
        img: '/images/products/77450-Silic-One-075.png',
        description:
            'Silic One is a biocide free, high solid fouling release system based on silicone and hydro gel. This gives a smooth even surface making it difficult for organisms to attach to the hull and facilitates self-cleaning when the boat is in motion. Suitable for use on all substrates, except wood, below the waterline.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['sea/ocean (Denmark)', 'lakes', 'rivers'],
        materialAllowed: ['aluminium', 'aluminum', 'fibreglass', 'plastic', 'steel', 'iron'],
        sailFrequency: ['medium', 'high', 'low'],
        shades: ['#006394', '#B30033', '#000000'],
        coverage: 8,
        keyFeatures: [
            {
                UK: ['Biocide free fouling release system', 'Good protection']
            },
            {
                US: ['Biocide free fouling release system', 'Good protection']
            },
            {
                Canada: ['Biocide free fouling release system', 'Good protection']
            },
            {
                Croatia: ['Neobraštajući sustav bez sadržaja biocida', 'Završni premaz']
            },
            {
                Denmark: ['Biocidfri fouling release system', 'Topcoat']
            },
            {
                Spain: ['Sistema antiadherente libre de biocidas', 'Acabado']
            },
            {
                Norway: ['Biocid fritt groeavvisnings system', 'Toppstrøk']
            },
            {
                Netherlands: ['Biocide free frouling release system', 'Topcoat']
            },
            {
                Finland: ['Biosidivapaa kasvillisuutta hylkivä järjestelmä', 'Pintamaali']
            },
            {
                Germany: ['Biozidfreies Fouling-Release-System', 'Endanstrich']
            },
            {
                Greece: ['Σύστημα αντιρύπανσης χωρίς βιοκτόνα', 'Topcoat']
            },
            {
                'Sweden - West Coast': ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            {
                Sweden: ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            {
                'Sweden - Lakes': ['Biocidfritt beväxningssläppande system', 'Täckfärg']
            },
            { France: ['Biocide free fouling release system', 'Bonne protection'] }
        ],
        alternativeProducts: ['string'],
        dateUpdated: 'Wed Mar 28 2018 13:37:52 GMT+0200 (CEST)',
        updatedBy: 'web@burza.hr',
        id: 73
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: 'https://www.hempelyacht.com/en-gb/products/hempaspeed-tf-77222',
        countryAllowed: ['UK'],
        position: 'best-buy-alternative',
        priority: 2,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 74
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: 'https://www.hempelyacht.com/da-dk/products/hempaspeed-tf-77222',
        countryAllowed: ['Denmark'],
        position: 'best-buy-alternative',
        priority: 2,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 75
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: 'https://www.hempelyacht.com/de-de/products/hempaspeed-tf-77222',
        countryAllowed: ['Germany'],
        position: 'best-buy-alternative',
        priority: 2,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 76
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: 'https://www.hempelyacht.com/fi-fi/products/hempaspeed-tf-77222',
        countryAllowed: ['Finland'],
        position: 'best-buy-alternative',
        priority: 2,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 77
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: ' https://www.hempelyacht.com/nb-no/products/hempaspeed-tf-77222',
        countryAllowed: ['Norway'],
        position: 'best-buy-alternative',
        priority: 2,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 78
    },
    {
        name: 'Hempaspeed TF',
        productId: '77222',
        productUrl: 'https://www.hempelyacht.com/nl-nl/products/hempaspeed-tf-77222',
        countryAllowed: ['Netherlands'],
        position: 'best-buy-alternative',
        priority: 2,
        img: '/images/products/Hempaspeed-TF_2_5L.png',
        description: 'Die Zukunft ist jetzt - nachhaltige Lösung für den Unterwasserschutz.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'steel', 'iron', 'aluminium', 'aluminum'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF', '#000000', '#1E2D56', '#6B6E6C'],
        coverage: 11,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Tvrd, tankoslojni, bez biocida',
                    'Nema kontaminacije otjecanjem',
                    'Jednostavan za pretvaranje',
                    'Ultra glatka završna obrada',
                    'Minimizira rast i povlačenje'
                ]
            },
            {
                Denmark: [
                    'Hård, tyndfilm, biocidfri',
                    'Ingen afløbsforurening',
                    'Let at konvertere',
                    'Ultraglat finish',
                    'Minimerer vækst og træk'
                ]
            },
            {
                Finland: [
                    'Kova, ohutkalvo, biosiditon',
                    'Ei valumiskontaminaatiota',
                    'Helppo muuntaa',
                    'Erittäin sileä viimeistely',
                    'Minimoi kasvun ja vedon'
                ]
            },
            {
                Norway: [
                    'Hard, tynnfilm, biocidfri',
                    'Ingen avrenningsforurensning',
                    'Enkel å konvertere',
                    'Ultra-myk finish',
                    'Minimerer vekst og luftmotstand'
                ]
            },
            {
                Sweden: [
                    'Hård, tunnfilm, biocidfri',
                    'Ingen avrinningsförorening',
                    'Lätt att konvertera',
                    'Ultralen finish',
                    'Minimerar tillväxt och motstånd'
                ]
            },
            {
                Germany: [
                    'Hart, dünnschichtig, biozidfrei',
                    'Keine Ablaufverschmutzung',
                    'Einfach zu konvertieren',
                    'Ultraglattes Finish',
                    'Minimiert Wachstum und Luftwiderstand'
                ]
            },
            { Spain: [] },
            {
                Netherlands: [
                    'Hard, dunne film, biocidevrij',
                    'Geen uitloopverontreiniging',
                    'Eenvoudig om te zetten',
                    'Ultragladde afwerking',
                    'Minimaliseert groei en weerstand'
                ]
            },
            {
                UK: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                US: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            {
                Canada: [
                    'Hard, thin-film, biocide-free',
                    'No run-off contamination',
                    'Easy to convert',
                    'Ultra- smooth finish',
                    'Minimizes growth & drag'
                ]
            },
            { France: [] }
        ],
        id: 79
    },
    {
        name: 'Hempel’s Hard Racing Xtra (Dove White)',
        productId: '7666C',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-hard-racing-xtra-7666a',
        countryAllowed: ['Denmark', 'Norway'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7666A-Hard-Racing-Xtra-075.png',
        description:
            'Er en højtydende, hård antifouling, der giver fremragende beskyttelse og en glat racerfinish hele sæsonen. Som antifouling til både af glasfiber, træ, krydsfiner og stål. Må ikke anvendes på aluminium eller andre metallegeringer. Risiko for korrosion i tilfælde af direkte kontakt. Til motorbåde og regatta-yachter.',
        boatType: ['motor-fast', 'motor-slow'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#006394', '#B30033', '#00275D'],
        coverage: 12.8,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: [] }
        ],
        id: 80
    },
    {
        name: 'Hempel’s Hard Racing TecCel (Dove White)',
        productId: '7683E',
        productUrl:
            'https://www.hempelyacht.com/en-GB/products/hempels-hard-racing-teccel-white-7679a',
        countryAllowed: ['Croatia', 'Greece', 'France'],
        position: 'premium',
        priority: 2,
        img: '/images/products/7679A-HardRacingTeccel-2,5.png',
        description:
            'High performance, hard antifouling providing outstanding protection all season. Includes TecCel technology which ensures reduced friction and increased speed. Can be used on glass fibre, wood, plywood, steel and aluminium. For power boats and regatta yachts.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'wood',
            'plywood',
            'plastic',
            'iron',
            'steel',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#FFFFFF'],
        coverage: 12.5,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: ['Dur antifouling', 'Excellente protection', 'Yachts à moteur et de régate'] }
        ],
        id: 81
    },
    {
        name: 'Hempel’s Hard Racing Xtra (Dove White)',
        productId: '7666C',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-hard-racing-xtra-7666a',
        countryAllowed: ['Finland'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7666A-Hard-Racing-Xtra-075.png',
        description:
            'Er en højtydende, hård antifouling, der giver fremragende beskyttelse og en glat racerfinish hele sæsonen. Som antifouling til både af glasfiber, træ, krydsfiner og stål. Må ikke anvendes på aluminium eller andre metallegeringer. Risiko for korrosion i tilfælde af direkte kontakt. Til motorbåde og regatta-yachter.',
        boatType: ['sailing', 'motor-fast', 'motor-slow'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'wood',
            'plywood',
            'steel',
            'iron',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#747476', '#000000', '#006394', '#B30033', '#00275D'],
        coverage: 12.8,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: [] }
        ],
        id: 82
    },
    {
        name: 'Hempel’s Hard Racing (Dove White)',
        productId: '7668E',
        productUrl: 'https://www.hempelyacht.dk/da-DK/products/hempels-hard-racing-xtra-7666a',
        countryAllowed: ['Spain'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/Hard-Racing.png?v=2',
        description:
            'Er en højtydende, hård antifouling, der giver fremragende beskyttelse og en glat racerfinish hele sæsonen. Som antifouling til både af glasfiber, træ, krydsfiner og stål. Må ikke anvendes på aluminium eller andre metallegeringer. Risiko for korrosion i tilfælde af direkte kontakt. Til motorbåde og regatta-yachter.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean (Denmark)', 'sea/ocean'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'wood',
            'plywood',
            'steel',
            'iron',
            'aluminium',
            'aluminum'
        ],
        sailFrequency: ['low', 'medium'],
        shades: ['#747476', '#000000', '#006394', '#B30033', '#00275D'],
        coverage: 12.8,
        alternativeProducts: '',
        keyFeatures: [
            {
                Croatia: [
                    'Protuobraštajni premaz tvrdoga tipa',
                    'Odlična zaštita',
                    'Motorne i regatne jahte'
                ]
            },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            {
                Finland: [
                    'Kova antifouling-maali',
                    'Erittäin hyvä suojaus',
                    'Moottori- ja kilpapurjeveneille'
                ]
            },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            {
                Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar']
            },
            {
                Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten']
            },
            {
                Spain: [
                    'Antiincrustante de matriz dura',
                    'Protección excelente',
                    'Motoras y barcos de regata'
                ]
            },
            {
                Netherlands: [
                    'Harde Antifouling',
                    'Uitstekende bescherming',
                    'Motorboten en wedstrijdjachten'
                ]
            },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { Canada: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { France: [] }
        ],
        id: 83
    },
    {
        name: 'Hempel’s Cruising Performer (Dove White)',
        productId: '7168E',
        productUrl: 'https://www.hempelyacht.com/en-GB/products/hempels-cruising-performer-7168e',
        countryAllowed: ['Spain'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/7168E-Cruising-Performer-25.png',
        description:
            'Self-polishing, erodible antifouling with very latest eroding technology which reduces the build up of paint, maximizing cruising capability in all areas, whilst ensuring fouling is kept to a minimum. An excellent coverage rate and colour stability ensures Hempel’s Cruising Performer offers you the very best in value. Suitable for use on all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-slow', 'motor-fast', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'plastic', 'wood', 'plywood', 'steel', 'iron'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#000000', '#00275D', '#006394', '#B50938'],
        coverage: 14.3,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Odlična zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Ausgezeichneter Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Excellent protection'] },
            { US: ['Self-polishing antifouling', 'Excellent protection'] },
            { Canada: ['Self-polishing antifouling', 'Excellent protection'] },
            { France: [] }
        ],
        id: 84
    },
    {
        name: 'Hempel’s Hard Racing Light',
        productId: '76765',
        productUrl: '',
        countryAllowed: ['Sweden', 'Sweden - East Coast', 'Sweden - West Coast', 'Sweden - Lakes'],
        position: 'best-buy',
        priority: 1,
        img: '/images/products/Hempel-cans-Hard-Racing-Light_2-5-Highres.png',
        description: '',
        boatType: ['motor-fast', 'motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean', 'rivers', 'lakes'],
        materialAllowed: [
            'fibreglass',
            'plastic',
            'steel',
            'iron',
            'wood',
            'plywood',
            'aluminum',
            'aluminium'
        ],
        sailFrequency: ['low', 'medium', 'high'],
        shades: ['#000000'],
        coverage: 12,
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] },
            { Canada: [] },
            { France: [] }
        ],
        id: 85
    }
]

// Small addition for "safe use note" because it should not be seen on silic one or hempaspeed or ecopower
hempelProducts.forEach(p => {
    const nm = String((p && p.name) || '').toLowerCase()
    const isExcluded =
        nm.indexOf('silic one') !== -1 ||
        nm.indexOf('hempaspeed tf') !== -1 ||
        nm.indexOf('ecopower') !== -1
    if (!isExcluded) {
        p.note = SAFE_USE_NOTES
    }
})
